module.exports = __webpack_public_path__ + "static/P2101540-6f4db110dd87b245f1556b9d5be1db2f.jpg";